import { tokens } from "@fluentui/react-components";
import {
    InfoRegular,
    CheckmarkCircleRegular,
    WarningRegular,
    ErrorCircleRegular,
    SearchFilled,
    LocalLanguageFilled,
    ThinkingRegular,
} from "@fluentui/react-icons";


export const alertConfig = {
    info: {
        icon: InfoRegular,
        color: "#005fb8",
        bgColor: tokens.colorNeutralBackground3,
    },
    success: {
        icon: CheckmarkCircleRegular,
        color: "#107c10",
        bgColor: "#107c1010",
    },
    warning: {
        icon: WarningRegular,
        color: "#b55e00",
        bgColor: `#b55e0010`,
    },
    error: {
        icon: ErrorCircleRegular,
        color: "#a4262c",
        bgColor: `#a4262c10`,
    },
    indicator: {
        icon: SearchFilled,
        color: "#0A78D5",
        bgColor: "transparent",
    },
    language: {
        icon: LocalLanguageFilled,
        color: "#0A78D5",
        bgColor: "transparent",
    },
    thinking: {
        icon: ThinkingRegular,
        color: "#0A78D5",
        bgColor: "transparent",
    },

} as const;

export type alertConfigType = keyof typeof alertConfig;
